import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText } from 'react-icons/fi';
import logo from '../assets/logo.png';

const TermsOfService = () => {
  return (
    <div className="bg-gray-50 min-h-screen font-sans">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <Link to="/">
            <img src={logo} alt="Jaapand-e" className="h-8" />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg">
          <div className="text-center mb-10">
            <FiFileText className="mx-auto h-12 w-12 text-brand-blue" />
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-4">Conditions Générales d'Utilisation</h1>
            <p className="text-gray-500 mt-2">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          <div className="prose prose-lg max-w-none text-gray-700">
            <p>
              Les présentes Conditions Générales d'Utilisation (CGU) régissent votre accès et votre utilisation du service Jaapand-e. En vous inscrivant ou en utilisant notre service, vous acceptez d'être lié par ces conditions.
            </p>

            <h2>1. Description du Service</h2>
            <p>
              Jaapand-e est une application web (SaaS) conçue pour aider les commerçants et petites entreprises à gérer leur stock, leurs ventes, leurs dépenses et leurs dettes clients/fournisseurs. Le service est accessible via un navigateur web sur ordinateur et mobile.
            </p>

            <h2>2. Comptes et Abonnements</h2>
            <ul>
              <li><strong>Inscription :</strong> Pour utiliser Jaapand-e, vous devez créer un compte en fournissant des informations exactes. Vous êtes responsable de la sécurité de votre mot de passe et de toutes les activités qui se déroulent sous votre compte.</li>
              <li><strong>Abonnements :</strong> Jaapand-e propose plusieurs niveaux d'abonnement ("Essentiel", "Pro", "Premium"). Certaines fonctionnalités ne sont accessibles qu'avec des abonnements payants.</li>
              <li><strong>Paiement :</strong> Pour les plans payants, le paiement s'effectue manuellement via les options proposées (ex: Wave, Orange Money). L'activation du plan est effectuée par notre équipe après réception et vérification de la preuve de paiement. Les abonnements sont mensuels et non remboursables.</li>
            </ul>

            <h2>3. Vos Responsabilités</h2>
            <ul>
              <li>Vous êtes seul responsable de l'exactitude des données que vous saisissez dans l'application (prix, quantités, etc.).</li>
              <li>Vous vous engagez à ne pas utiliser le service à des fins illégales ou non autorisées.</li>
              <li>Vous ne devez pas tenter de perturber ou de compromettre l'intégrité ou la sécurité de nos systèmes.</li>
            </ul>

            <h2>4. Propriété Intellectuelle</h2>
            <p>
              Le service Jaapand-e et son contenu original (à l'exception des données que vous fournissez), ses caractéristiques et ses fonctionnalités sont et resteront la propriété exclusive de Taysir Software et de ses concédants de licence.
            </p>

            <h2>5. Limitation de Responsabilité</h2>
            <p>
              Le service est fourni "tel quel". Bien que nous nous efforcions de fournir un service fiable et sécurisé, nous ne garantissons pas que le service sera ininterrompu ou sans erreur. En aucun cas, Jaapand-e ne sera responsable de toute perte de profits, de données ou de tout dommage indirect résultant de votre utilisation du service. Notre responsabilité est strictement limitée au montant que vous avez payé pour le service au cours des 12 derniers mois.
            </p>

            <h2>6. Modification des Conditions</h2>
            <p>
              Nous nous réservons le droit de modifier ces conditions à tout moment. Si une révision est importante, nous nous efforcerons de fournir un préavis d'au moins 30 jours avant l'entrée en vigueur des nouvelles conditions. En continuant à utiliser le service après l'entrée en vigueur de ces révisions, vous acceptez d'être lié par les conditions révisées.
            </p>

            <h2>7. Résiliation</h2>
            <p>
              Nous pouvons résilier ou suspendre votre compte immédiatement, sans préavis ni responsabilité, pour quelque raison que ce soit, y compris, sans s'y limiter, si vous ne respectez pas les présentes Conditions.
            </p>

            <h2>8. Contact</h2>
            <p>
              Pour toute question concernant ces Conditions Générales d'Utilisation, veuillez nous contacter à <a href="mailto:contact@jaapand-e.com">contact@jaapand-e.com</a>.
            </p>
          </div>
        </div>
      </main>

      <footer className="text-center py-6 text-gray-500 text-sm">
        <p>&copy; {new Date().getFullYear()} Jaapand-e. Tous droits réservés.</p>
        <Link to="/" className="text-brand-blue hover:underline mt-2 inline-block">Retour à l'accueil</Link>
      </footer>
    </div>
  );
};

export default TermsOfService;